export function isMobileDevice() {
  return /iPhone|iPad|iPod|Android|Mobile/i.test(navigator.userAgent);
}